import * as types from '../../constants/ActionTypes';
import service from '../../service/';

export const setSteps = data => ({
    type: types.SET_STEPS,
    data,
});

export const setStep = step => ({
    type: types.SET_STEP,
    step,
});

export const setStepCompleted = (step, status) => ({
    type: types.SET_STEP_COMPLETED,
    step,
    status,
});

export const setStepsUncompleted = fromStep => ({
    type: types.SET_STEPS_UNCOMPLETED,
    fromStep,
});

export const loadApplicationData = () => ({
    type: types.LOAD_APPLICATION_DATA,
    payload: service.loadApplicationData(),
});



// WEBPACK FOOTER //
// ./src/app/FormStepper/formStepperActions.js